module.exports = __webpack_public_path__ + "static/img/30020 (4).7417022.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30020 (4).webp
// module id = XiK6
// module chunks = 14